import React from 'react';
import history from '../../modules/History';
import { Button, notification } from 'antd';
import ReactTable from 'react-table'
import { getLuckyWheels } from '../../modules/Api';
import ACL from '../../components/ACL';

const btnStyle = {
    color: '#fff',
    borderRadius: '4px',
    padding: '8px',
    cursor: 'pointer',
    margin: '0 2px',
    width: '75px',
    display: 'inline-block',
    marginTop: '-5px',
    marginBottom: '-5px',
}

class LuckyWheels extends React.Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 10,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        getLuckyWheels((res) => {
            this.setState({items: res, count: res.length, pageSize: res.length});
        });
    }

    onChange(state) {

    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
                filterable: false,
            },
            {
                Header: 'عنوان',
                accessor: 'title',
                filterable: false,
                Cell: (row) => (<ACL component="span" has_permission="lucky_wheels_management|lucky_wheels_edit" denied={() => {return row.original.title;}} ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}}
                                      title={row.original.action} onClick={() => {
                                        window.open(`/lucky_wheels/edit/${row.original.id}`, "_blank")
                                      }
                                      }> {row.original.title} </span></ACL>)
            },
            {
                Header: 'تعداد آیتم ها',
                accessor: 'segment_count',
                filterable: false,
            },
            {
                Header: 'تعداد آیتم خالی ها',
                accessor: 'empty_count',
                filterable: false,
            },
            {
                Header: 'لینک گردونه',
                accessor: 'url',
                filterable: false,
                sortable: false,
                Cell: (row) => (row.original.is_active ?  <a target="_blank" href={row.original.href}>لینک</a> : 'گردونه غیر فعال است')
            }
        ];


        return (
            <div style={{textAlign: 'center'}}>
                <ACL component="span" has_permission="lucky_wheels_management|lucky_wheels_add"><div className="btn-container">
                    <Button type="primary" onClick={() => history.item.push(`/lucky_wheels/add`)}>افزودن گردونه جدید</Button>
                </div>
                </ACL>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}


export default LuckyWheels;


// WEBPACK FOOTER //
// ./src/containers/LuckyWheels/index.js